import { select, call, put, takeLatest } from 'redux-saga/effects'
import { defineTypes } from '../../helpers'
import ReservationEndpoint from '../../persistence/ReservationEndpoint'
import { reduxFetch } from '../../http/reduxFetch'
import moment from 'moment'
import activeJsonApi from '../../json-api'

const reservationShow = { ...defineTypes('RESERVATION_SHOW')  }
const reservationShowStore = new activeJsonApi('show_reservations')

export const initialState = {
  loading: false,
  loaded: false,
  order: undefined,
  query: undefined,
  search: undefined,
}

export const actions = {
  showReservation (id) {
    return { type: reservationShow.REQUEST, id: id }
  },
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case reservationShow.REQUEST:
      return { ...state, query: action.query, started: true, loading: true }
    case reservationShow.FAILURE:
      return { ...state, loading: false, error: action.error }
    case reservationShow.SUCCESS:
      return { ...state, loading: false, order: action.order, loaded: true, created: true }
    default:
      return state
  }
}
export const selectors = {
  order: (store) => {
    return store.reservation_show.order
  },
  customer: (reservation) => {
    let id = reservation['relationships']['customer'] &&
      reservation['relationships']['customer']['data'] &&
      reservation['relationships']['customer']['data']['id']
    return reservationShowStore.getObject('customers', id)
  }
}

export function * showReservationsSaga (action) {
  try {
    let response = yield call(reduxFetch, ReservationEndpoint.show(action.id))
    reservationShowStore.reset()
    reservationShowStore.updateStore(response)
    yield put({ type: reservationShow.SUCCESS, order: response.data })
  } catch (error) {
    yield put({ type: reservationShow.FAILURE, error })
  }
}
export function * rootSaga () {
  yield takeLatest(reservationShow.REQUEST, showReservationsSaga)
}




// WEBPACK FOOTER //
// ./src/sagas/reservation/show.js